import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';
import 'alertifyjs/build/css/alertify.css';
import { ValidateAdminRole } from '../../../../../helper/validateRole';
import { Auth } from 'aws-amplify';
import Layout from '../../../../../components/common/nav/admin/nav.component';
import AWS from "aws-sdk"
import Login from '../../../../../setup/auth/login.component';
import { GetValueFromArray,graphQLGetAllData } from '../../../../../helper/commonfunctions';
import { FilterMatchMode } from 'primereact/api';
import awsmobile from "../../../../../aws-exports";
import moment from 'moment';

export default function TimeReportMasterList() {

    //filter data
    const dtApp = useRef(null);

    //Validate admin Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [allSchools, setAllSchools] = useState("");
    const [state, setState] = useState(false);
    const [allFormData, setAllFormData] = useState([]);
    const [allTimeReport, setAllTimeReport] = useState([]);
    const [timeReportEmployeesList, setTimeReportEmployeesList] = useState([]);
    const [timeReportEmployeeDetailsList, setTimeReportEmployeeDetailsList] = useState([]);
    const [timeReportTransactionCycleList, setTimeReportTransactionCycleList] = useState([]);
    const [allEmployeeList, setAllEmployeeList] = useState([]);
    const [dates, setDates] = useState([]);
    const [reportLoading, setReportLoading] = useState(true);
    const [filters, setFilters] = useState({
        empCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        empName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        notes: { value: null, matchMode: FilterMatchMode.CONTAINS },
        startDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
        endDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
        schoolName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
        accountNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        totalWorkingHours: { value: null, matchMode: FilterMatchMode.CONTAINS },
        type: { value: null, matchMode: FilterMatchMode.CONTAINS },
        payRate: { value: null, matchMode: FilterMatchMode.CONTAINS },
        payType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        approvalStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
        approvalOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
        approvalBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });


    const exportFilteredDataToCSV = async (fileName) => {
        dtApp.current.exportCSV('');
    }

    const CounterAction = (row, index) => {
        return (
            (index.rowIndex) + 1
        );
    };


    async function GetUserData(userId) {
        const cognito = await new AWS.CognitoIdentityServiceProvider();
        let submittedUser = "";
        let submittedBy = "-";

        if (userId) {
            try {
                submittedUser = await cognito.adminGetUser({
                    UserPoolId: awsmobile.aws_user_pools_id,
                    Username: userId,
                }).promise();

                let exist = submittedUser ? submittedUser : '';
                let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                let name = GetValueFromArray(exist.UserAttributes, "name");

                submittedBy = lastName + ", " + firstName ? lastName + ", " + firstName : name;
            } catch (e) {
                //console.log(e)
            }
        } else {
            submittedBy = "-"
        }
        return submittedBy;
    }

    //Get All List -Asharani Navale- Sept/29/2023
    async function BindList() {

        try {

            //Time Report
            var TimeReportInitiateReports = await graphQLGetAllData("listTimeReportInitiateReports");
            TimeReportInitiateReports = TimeReportInitiateReports.sort((a, b) => (a.Created_By_Date).localeCompare(b.Created_By_Date));
            setAllTimeReport(TimeReportInitiateReports);

            let timeReportEmployeesData = await graphQLGetAllData("listTimeReportEmployees")
            setTimeReportEmployeesList(timeReportEmployeesData)

            let timeReportEmployeeDetailsData = await graphQLGetAllData("listTimeReportEmployeeDetails")
            setTimeReportEmployeeDetailsList(timeReportEmployeeDetailsData)

            let timeReportTransactionCycleData = await graphQLGetAllData("listTimeReportTransactionCycles")
            setTimeReportTransactionCycleList(timeReportTransactionCycleData)

            let getAllEmployeeList = await graphQLGetAllData("listEmployees")
            setAllEmployeeList(getAllEmployeeList)

            var getAllSchools = await graphQLGetAllData("listSchools")
            setAllSchools(getAllSchools)
            setState(true);
        }
        catch (error) {
            console.log(error);
        }

    }

    async function GetAllAppData() {

        try {

            //Asharani Navale- Sept/29/2023
            let completeData = [];

            //Time Report
            console.log(allTimeReport, 'allTimeReportData')
            for (let i = 0; i < allTimeReport.length; i++) {

                var transactionCycleData = timeReportTransactionCycleList.filter(e => e.report_Id && e.report_Id.includes(allTimeReport[i].id))

                transactionCycleData = transactionCycleData.sort((b, a) => (a.customUpdatedAt ?? "").localeCompare(b.customUpdatedAt ?? ""));

                let approvalBy = '-';
                let approvalOn = '-';
                
                if(transactionCycleData[0]){
                    approvalBy = await GetUserData(transactionCycleData[0].to_Employee_Id)
                    approvalOn = transactionCycleData[0].customUpdatedAt ? moment(transactionCycleData[0].customUpdatedAt).format('MM/DD/YYYY') : moment(allTimeReport[i].updatedAt).format('MM/DD/YYYY');
                }

                let approvalStatus = transactionCycleData.length > 0 ? transactionCycleData[0].status : 'Pending';
                let schoolName = allSchools.find(o => o.id === allTimeReport[i].school_Department_Id)
                let startDate = allTimeReport[i].From_Date ? moment(allTimeReport[i].From_Date).format('MM/DD/YYYY') : '-';
                let endDate = allTimeReport[i].To_Date ? moment(allTimeReport[i].To_Date).format('MM/DD/YYYY') : '-';
                let notes = allTimeReport[i].Notes;
                let rate = allTimeReport[i].Daily_Rate;
                let type = allTimeReport[i].Type;
                let accountNo = allTimeReport[i].Account;
                let payRate = allTimeReport[i].Daily_Rate ? allTimeReport[i].Daily_Rate : allTimeReport[i].Hourly_Rate ? allTimeReport[i].Hourly_Rate:'-';
                let payType = '-'
                if (allTimeReport[i].Daily_Rate) {
                    payType = 'Daily';
                }
                else if (allTimeReport[i].Hourly_Rate) {
                    payType = 'Hourly';
                }

                // let submittedByData = GetUserData(allTimeReport[i].Created_By);

                let submittedByData = allEmployeeList.find(o => o.user_Id && o.user_Id === allTimeReport[i].Created_By)
                console.log(submittedByData, 'submittedBy')

                const timeReportEmpResp = timeReportEmployeesList.filter(e => e.time_Report_Id.includes(allTimeReport[i].id))

                let empData = [];
                let empTableData = [];

                for (let j = 0; j < timeReportEmpResp.length; j++) {

                    //particular employee get details data
                    const timeReportEmpDetailsResp = timeReportEmployeeDetailsList.filter(e => e.time_Report_Employee_Id.includes(timeReportEmpResp[j].id))
                    console.log('timeReportEmpDetailsResp', timeReportEmpDetailsResp)
                    let object = {};
                    for (let k = 0; k < allEmployeeList.length; k++) {

                        var employeeResponses1 = allEmployeeList.find(o => o.id === timeReportEmpResp[j].employee_Id)

                        let empName = ''
                        let userCode = ''

                        if (employeeResponses1) {
                            empName = employeeResponses1.employee_name;
                            userCode = employeeResponses1.employee_code
                        }
                        object = {
                            startDate: startDate,
                            endDate: endDate,
                            notes: notes,
                            rate: rate,
                            type: type,
                            accountNo: accountNo,
                            empCode: userCode,
                            empName: empName,
                            submittedBy: submittedByData ? submittedByData.lastName + ", " + submittedByData.firstName : '-',
                            schoolName: schoolName.name + " (" + schoolName.code + ")",
                            payRate: payRate,
                            payType: payType,
                            approvalStatus: approvalStatus,
                            approvalBy: approvalBy,
                            approvalOn: approvalOn,
                            totalWorkingHours: Math.round((timeReportEmpResp[j].totalEmployeeWorkingHours) * 100) / 100 + 'hrs'
                        };
                        for (let m = 0; m < timeReportEmpDetailsResp.length; m++) {

                            const startDate = new Date(timeReportEmpDetailsResp[m].date); // Replace with your start date
                            const month = startDate.toLocaleString('default', { month: 'short' });
                            const formattedDate = startDate.getDate().toString().padStart(2, '0') + ' ' + month;
                            // let day = new Date(timeReportEmpDetailsResp[m].date).getDate();
                            let workHours = timeReportEmpDetailsResp[m].totalHours;
                            const attributeName = formattedDate; // Generate attribute name based on index
                            const attributeValue = workHours + 'hrs'; // Get value from array
                            object[attributeName] = attributeValue; // Assign value to object attribute
                        }
                        break;
                        // }
                    }
                    completeData.push(object);
                }

            }

            setReportLoading(false)
            const dates = [];
            console.log(completeData[0].endDate, 'completeData[0].endDate')

            const currentDate = new Date('2023-08-01');
            const lastDate = new Date('2023-10-01');

            // const currentDate = new Date(specificReportDetailsView.startDate);
            // const lastDate = new Date(specificReportDetailsView.endDate);
            while (currentDate <= lastDate) {

                // let formattedDate = currentDate.getDate();
                const month = currentDate.toLocaleString('default', { month: 'short' });
                const formattedDate = currentDate.getDate().toString().padStart(2, '0') + ' ' + month;

                // dates.push(new Date(currentDate));
                dates.push(formattedDate);
                currentDate.setDate(currentDate.getDate() + 1);
            }

            console.log('completeData', completeData)
            setAllFormData(completeData);
            setDates(dates)
        }
        catch (error) {
            console.log(error);
        }
    }

    async function onLoad() {
        try {
           await Auth.currentSession();
           if (!ValidateAdminRole()) { userHasAuthenticated(false); }
        } catch (e) {
           console.log("error-->", e)
           userHasAuthenticated(false);
        }
     }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);

    useEffect(() => {
        if (state === true) {
            GetAllAppData();
        }
    }, [state]);

    return isAuthenticated ? (
        <div>
            <Layout pageTitle="Dashboard">

                <div className="">
                    <div className="dashboard-main-wrapper pr-4 mt-3">
                        <div className='wrapper-custom-views mt-8'>

                            <div className="flex flex-1 flex-wrap pt-5 px-0 top-action-wrapper mt-4">
                                <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                    <div className="md:flex block mb-4">
                                        <h2 className="page-title ">Time Report</h2>
                                    </div>
                                </div>
                                <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side mb-4">
                                    <Link
                                        to="#"
                                        onClick={(e) => {
                                            exportFilteredDataToCSV("FormReport.csv");
                                            e.preventDefault()
                                        }}
                                        className=" "
                                    >
                                        {" "}
                                        <i className="pi pi-download "></i>
                                    </Link>

                                    <div className="md:flex block gap-3">
                                        <Link to="/masters" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231]  dark:text-[#FFFFFF]">Back</Link>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className={allFormData.length === 0 ? "datatableemptymessage arrowhide" : "payroll  arrowshow"}>

                                    <DataTable ref={dtApp} className="custpaginator custIcons custmBtnTable custTable border-1" filters={filters} filterDisplay="row" sortOrder="1" sortField="schoolName" scrollable value={allFormData} paginator rows={10} rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" loading={reportLoading}
                                        emptyMessage="No data found."
                                    >
                                        <Column header="SL#" body={CounterAction} style={{ minWidth: '3rem' }}></Column>
                                        <Column field="schoolName" header="School / Department Name" filter filterPlaceholder="Search" sortable style={{ minWidth: '8rem' }}></Column>
                                        <Column field="submittedBy" header="Submitted By" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="type" header="Type" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>

                                        <Column field="accountNo" header="Account No" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="payType" header="Rate Type" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>

                                        <Column field="payRate" header="Rate" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="approvalStatus" header="Approval Status" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="approvalBy" header="Approval By" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="approvalOn" header="Approval On" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        
                                        <Column field="startDate" header="From Date" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>
                                        <Column field="endDate" header="To Date" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>

                                        <Column field="notes" header="Notes" filter filterPlaceholder="Search" sortable style={{ minWidth: '7rem' }}></Column>

                                        <Column field="empCode" header="Emp ID" sortable style={{ minWidth: '3rem' }}></Column>
                                        <Column field="empName" header="Emp Name" sortable></Column>
                                        {/* <Column field="payRate" header="Pay Rate/Hr" sortable style={{ minWidth: '5rem' }}></Column>  */}
                                        {
                                            dates.map((currentItem) => {

                                                return (
                                                    <Column field={`${(currentItem === "" || currentItem === null ? "-" : currentItem)}`} header={currentItem} sortable style={{ minWidth: '5rem' }}></Column>
                                                );
                                            })
                                        }
                                        <Column field="totalWorkingHours" header="Total Hrs" sortable style={{ minWidth: '5rem' }} alignFrozen="right" frozen={true}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    ) : (
        <Login sessionExpired={1} />
    )
}